import { render } from "./regNoList.vue?vue&type=template&id=f9ce5508"
import script from "./regNoList.vue?vue&type=script&lang=js"
export * from "./regNoList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/khatanbaatarb/Documents/projects/roadpay.mn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__